import moment from 'moment';

export default function MRReportInstanceController(
  $scope,
  $rootScope,
  loaderService,
  reportsDataService,
  reportsSharedModelService,
  ssDialogService,
  confirmDialog,
  alerts,
  editReportInstanceCommentDialog,
  editReportStatusDialog,
) {
  const vm = this;

  vm.handleExpand = _handleExpand;

  vm.handleAddNote = _handleAddNote;
  vm.handleEditAcknowledgeStatus = _handleEditAcknowledgeStatus;
  vm.handlePublishReport = _handlePublishReport;
  vm.handleArchiveReport = _handleArchiveReport;
  vm.handleDeleteReport = _handleDeleteReport;

  _activate();

  /** ********************************************
   * Event Handlers
   */

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleAddNote($event) {
    ssDialogService.dialogs.reports.editReportInstanceCommentDialog = ssDialogService.alert(
      editReportInstanceCommentDialog.getOptions($event, {
        reportInstanceComment: {
          reportInstanceId: vm.reportInstance.reportInstanceId,
          reportInstanceCommentId: 0,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.editReportInstanceCommentDialog);
  }

  function _handleEditAcknowledgeStatus($event) {
    loaderService.showViewLoader = true;
    return reportsDataService.getAcknowledgeStatuses().then((response) => {
      loaderService.showViewLoader = false;
      ssDialogService.dialogs.reports.editReportStatusDialog = ssDialogService.alert(
        editReportStatusDialog.getOptions($event, {
          reportInstance: vm.reportInstance,
          statuses: response.data.result,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.reports.editReportStatusDialog);
    });
  }

  function _handlePublishReport() {
    loaderService.showViewLoader = true;
    return reportsSharedModelService
      .publishReportInstance(vm.reportInstance.reportId, vm.reportInstance.reportInstanceId, vm.reportInstance.familyId)
      .then((success) => {
        loaderService.showViewLoader = false;
        if (success) {
          $rootScope.$broadcast(`reports.myReports.reportType.reportInstancePublished`, vm.reportInstance); // eslint-disable-line max-len
          alerts.success('The Report has been successfully published to Financial Institution Reports.');
        } else {
          alerts.error('Error occurred while publishing the Report.');
        }
      });
  }
  
  function _handleArchiveReport($event) {
    const reportName = vm.reportInstance.reportName;
    const generatedDate = moment(vm.reportInstance.createDate).format('MM/DD/YYYY');
    const generatedTime = moment(vm.reportInstance.createDate).format('hh:mm:ss a');

    return _showArchiveConfirmDialog($event, {
      dialogTitle: 'Archive Report?',
      message: `Are you sure you want to archive the "${reportName}" Report Instance generated on ${generatedDate} at ${generatedTime}?`,
      handleYesClick: _confirmArchive,
      handleNoClick: _closeArchiveConfirmDialog,
    });
  }

  function _showArchiveConfirmDialog($event, locals) {
    ssDialogService.dialogs.reports.archiveMyReportInstanceConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.archiveMyReportInstanceConfirmDialog);
  }

  function _closeArchiveConfirmDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.archiveMyReportInstanceConfirmDialog);
  }

  function _confirmArchive() {
    loaderService.showViewLoader = true;
    return reportsDataService.archiveReportInstance(vm.reportInstance.reportInstanceId).then((success) => {
      loaderService.showViewLoader = false;
      if (success) {
        $rootScope.$broadcast(`reports.myReports.reportType.reportInstanceArchived`, vm.reportInstance); // eslint-disable-line max-len
        alerts.success('The Report Instance has been successfully archived.');
        _closeArchiveConfirmDialog();
      } else {
        alerts.error('An error occurred while archiving the Report Instance.');
      }
    });
  }
  
  function _handleDeleteReport($event) {
    const reportName = vm.reportInstance.reportName;
    const generatedDate = moment(vm.reportInstance.createDate).format('MM/DD/YYYY');
    const generatedTime = moment(vm.reportInstance.createDate).format('hh:mm:ss a');

    return _showDeleteConfirmDialog($event, {
      dialogTitle: 'Delete Report?',
      message: `Are you sure you want to delete the "${reportName}" Report Instance generated on ${generatedDate} at ${generatedTime}?`,
      handleYesClick: _confirmDelete,
      handleNoClick: _closeDeleteConfirmDialog,
    });
  }

  function _showDeleteConfirmDialog($event, locals) {
    ssDialogService.dialogs.reports.deleteMyReportInstanceConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.deleteMyReportInstanceConfirmDialog);
  }

  function _closeDeleteConfirmDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.deleteMyReportInstanceConfirmDialog);
  }

  function _confirmDelete() {
    loaderService.showViewLoader = true;
    return reportsDataService.deleteReportInstance(vm.reportInstance.reportInstanceId).then((success) => {
      loaderService.showViewLoader = false;
      if (success) {
        $rootScope.$broadcast(`reports.myReports.reportType.reportInstanceDeleted`, vm.reportInstance); // eslint-disable-line max-len
        alerts.success('The Report Instance has been successfully deleted.');
        _closeDeleteConfirmDialog();
      } else {
        alerts.error('An error occurred while deleting the Report Instance.');
      }
    });
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {
    vm.canExpand = false;
    vm.isExpanded = false;

    if (vm.reportInstance.reportInstanceComments !== null) {
      vm.canExpand = true;
    }

    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshReportStatus', (event, opt) => {
      if (opt.reportInstanceId === vm.reportInstance.reportInstanceId) {
        _updateReportStatus();
        _loadComments();
      }
    });

    $scope.$on('refreshReportInstanceComments', (event, opt) => {
      if (opt.reportInstanceId === vm.reportInstance.reportInstanceId) {
        _loadComments();
      }
    });
  }

  function _updateReportStatus() {
    loaderService.showViewLoader = true;
    return reportsDataService.getReportInstance(vm.reportInstance.reportInstanceId).then((response) => {
      loaderService.showViewLoader = false;
      vm.reportInstance.acknowledgeStatusId = response.data.acknowledgeStatusId;
      vm.reportInstance.acknowledgeStatus = response.data.acknowledgeStatus;
    });
  }

  function _loadComments() {
    loaderService.showViewLoader = true;
    return reportsDataService.getReportInstanceNotes(vm.reportInstance.reportInstanceId).then((response) => {
      loaderService.showViewLoader = false;
      vm.reportInstance.reportInstanceComments = response.data;

      if (vm.reportInstance.reportInstanceComments !== null) {
        vm.canExpand = true;
      } else {
        vm.canExpand = false;
      }
    });
  }
}

MRReportInstanceController.$inject = [
  '$scope',
  '$rootScope',
  'loaderService',
  'reportsDataService',
  'reportsSharedModelService',
  'ssDialogService',
  'confirmDialog',
  'alerts',
  'editReportInstanceCommentDialog',
  'editReportStatusDialog',
];
